import { render } from "./LicensePage.vue?vue&type=template&id=17a22535&scoped=true"
import script from "./LicensePage.vue?vue&type=script&lang=js"
export * from "./LicensePage.vue?vue&type=script&lang=js"

import "./LicensePage.vue?vue&type=style&index=0&id=17a22535&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17a22535"]])

export default __exports__